module.exports = __webpack_public_path__ + "img/oaknest-1.242c32c0.jpeg";